const toggles = {
  logSentryToConsole: false,
  logTagManagerToConsole: false,
  enableServiceWorker: false
};

export default toggles;
